//regex solution can be found at  https://stackoverflow.com/a/46181/6627219
export const isValidMail = ( email: string, invalidDomains: string[] ) => {
    console.log( invalidDomains );
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isValidEmail = re.test( String( email ).toLowerCase() );

    let emailParts = email.split( '@' );
    let emailDomain = emailParts[1];

    if ( emailDomain === undefined ) {
        return false;
    }

    let invalidDomainUsed = invalidDomains.filter( domain => emailDomain.toUpperCase().startsWith( domain.toUpperCase() ) );
    let hasValidDomain = (Array.isArray( invalidDomainUsed ) && !invalidDomainUsed.length);

    return isValidEmail && hasValidDomain;
};
